export default "__VITE_ASSET__o0v8vMX6__"